import { sendEvent as sendEventYandex, sendEventN1 as sendEventYandexN1 } from '../../utils/yandexMetrika';
import { gtagReportConversion, sendEvent as sendEventGoogle } from '../../utils/googleAnalytics';

/**
 * Нажата кнопка "Избранное"
 */
export function eventAddFavorites () {
  sendEventYandex('search-bookmark-link');
}

/**
 * Нажата кнопка "Избранное"
 */
export function eventRemoveFavorites () {
  sendEventYandex('search-bookmark-link');
}

/**
 * Нажата кнопка "Комментарий"
 */
export function eventOpenCommentForm () {
  sendEventYandex('search-comment-link');
}

/**
 * Нажата кнопка "Пожаловаться"
 */
export function eventOpenClaimForm () {
  sendEventYandex('search-claim-link');
}

/**
 * Нажата кнопка "Показать на карте - модальное окно"
 */
export function eventMapModal () {
  sendEventYandex('modal-map');
}

/**
 * Нажата кнопка "Контакты"
 */
export function eventShowContacts () {
  gtagReportConversion();
  sendEventGoogle('пользователь', 'открыл контакты объявления на странице поиска объявлений');
  sendEventYandex('show-contacts');
  sendEventYandexN1('SHOW_CONTACTS_ALL');
}

/**
 * Нажата кнопка "Списком"
 */
export function eventShowViewPaper () {
  sendEventYandex('search-short');
}

/**
 * Нажата кнопка "Картой"
 */
export function eventShowViewMap () {
  sendEventYandex('search-map');
}

/**
 * Нажата кнопка "Сохранить поиск"
 */
export function eventSaveSearch () {
  sendEventYandex('search-save-search');
}

/**
 * Нажата кнопка "Создать подписку"
 */
export function eventSubscription () {
  sendEventYandex('subscription');
}



// WEBPACK FOOTER //
// ./src/app/Search/events.js